<template>
  <article class="kds-step-card">
    <span class="kds-step-card__number">{{ index }}</span>
    <KdsEyebrow class="kds-step-card__tag">{{ tag }}</KdsEyebrow>
    <h3 class="kds-step-card__title">{{ title }}</h3>
    <p class="kds-step-card__body">{{ body }}</p>
  </article>
</template>

<script setup lang="ts">
import KdsEyebrow from '@/kds/primitives/KdsEyebrow.vue';

interface Props {
  index: string;
  tag: string;
  title: string;
  body: string;
}

defineProps<Props>();
</script>

<style scoped lang="scss">
.kds-step-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);

  &__number {
    font-family: var(--font-mono);
    font-size: var(--fs-mono);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--stone);
  }

  &__title {
    margin: 0;
    font-size: var(--fs-h3);
    line-height: var(--lh-h3);
    color: var(--ink);
  }

  &__body {
    margin: 0;
    font-size: var(--fs-body);
    line-height: var(--lh-body);
    color: var(--stone);
  }
}
</style>
